import styled from 'styled-components';
import { ButtonV2 } from '@getgrover/ui';

export const StepWrapper = styled.div`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
`;

export const Title = styled.div`
    ${({ theme }) => theme.typography.Subheadline};
    color: ${({ theme }) => theme.colors.Foreground};
    margin-bottom: 16px;
`;

export const Text = styled.div`
    ${({ theme }) => theme.typography.Paragraph};
    color: ${props => props.theme.colors['Level 5']};
    margin-bottom: 16px;
`;

export const CapsHeadline = styled.div`
    ${({ theme }) => theme.typography.SmallCapsHeadline};
    color: ${(props) => props.theme.colors['Level 4']};
`;

export const Button = styled(ButtonV2)`
    margin-top: auto;
`;
